/*
 * Types.
 */

import {
  DecisionTreeData,
  DecisionTreeSettings,
} from '../../../../libs/shared/core/src/models/api/decisionTreeModel';

type FrontChatParams =
  | Record<string, string | boolean | object | undefined>
  | {
      top: number;
      left: number;
      right: number;
      bottom: number;
    };
type UnbindHandler = () => void;
export type FrontChatSdk = (cmdType: string, params?: FrontChatParams) => UnbindHandler | undefined;
export type FrontChatTreeData = DecisionTreeData & {
  id: number;
  updatedAt: number;
  settings: DecisionTreeSettings;
};

/*
 * Enum.
 */

export enum FrontChatCommandsEnum {
  INIT = 'init',
  SHUTDOWN = 'shutdown',
  SHOW = 'show',
  HIDE = 'hide',
  PREVIEW_SETTINGS = 'previewSettings',
  PREVIEW_CHATBOT = 'previewChatbot',
  SET_PAGE_INSET = 'setPageInset',
}
